export default __webpack_public_path__ + "static/media/loading.d0137190.gif";